import {
    Condition,
    DecimalCondition,
    DecimalConditionType,
    DecimalOperator,
} from "@tenforce/product-fields"
import { FilterParser } from "./index"
import { ConditionDTO } from "../../models/dto/conditions"
import { DecimalConditionDTO } from "../../models/dto/conditions/DecimalCondition"

export const DecimalConditionDTOType = "#TF.DecimalFieldCondition"
export enum DecimalOperatorDTO {
    IsEmpty = "IsEmpty",
    IsEqualTo = "IsEqualTo",
    IsNotEqualTo = "IsNotEqualTo",
    IsLessThan = "IsLessThan",
    IsLessThanOrEqualTo = "IsLessThanOrEqualTo",
    IsGreaterThan = "IsGreaterThan",
    IsGreaterThanOrEqualTo = "IsGreaterThanOrEqualTo",
}

const checkIfApplicable = (condition: Condition): boolean => {
    return condition?.type === DecimalConditionType
}
const checkIfApplicableDTO = (condition: ConditionDTO): boolean => {
    return condition["@type"] === DecimalConditionDTOType
}
const isValidNumber = (value: unknown): boolean => {
    return typeof value === "number"
}

const parseFromDTO = (condition: DecimalConditionDTO): DecimalCondition => {
    if (!checkIfApplicableDTO(condition)) {
        return null
    }
    let result: DecimalCondition = null
    switch (condition.Operator) {
        case DecimalOperatorDTO.IsEmpty: {
            result = {
                type: DecimalConditionType,
                operator: DecimalOperator.IsEmpty,
                value: null,
                isLocked: condition.IsLocked,
            }
            break
        }
        case DecimalOperatorDTO.IsEqualTo: {
            if (isValidNumber(condition.Value)) {
                result = {
                    type: DecimalConditionType,
                    operator: DecimalOperator.IsEqualTo,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        case DecimalOperatorDTO.IsNotEqualTo: {
            if (isValidNumber(condition.Value)) {
                result = {
                    type: DecimalConditionType,
                    operator: DecimalOperator.IsNotEqualTo,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        case DecimalOperatorDTO.IsLessThan: {
            if (isValidNumber(condition.Value)) {
                result = {
                    type: DecimalConditionType,
                    operator: DecimalOperator.IsLessThan,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        case DecimalOperatorDTO.IsLessThanOrEqualTo: {
            if (isValidNumber(condition.Value)) {
                result = {
                    type: DecimalConditionType,
                    operator: DecimalOperator.IsLessThanOrEqualTo,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        case DecimalOperatorDTO.IsGreaterThan: {
            if (isValidNumber(condition.Value)) {
                result = {
                    type: DecimalConditionType,
                    operator: DecimalOperator.IsGreaterThan,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        case DecimalOperatorDTO.IsGreaterThanOrEqualTo: {
            if (isValidNumber(condition.Value)) {
                result = {
                    type: DecimalConditionType,
                    operator: DecimalOperator.IsGreaterThanOrEqualTo,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        default:
            break
    }
    return result
}

const parseToDTO = (
    id: string,
    condition: DecimalCondition,
): DecimalConditionDTO | null => {
    if (!condition || !checkIfApplicable(condition)) {
        return null
    }
    let result: DecimalConditionDTO | null = null
    switch (condition.operator) {
        case DecimalOperator.IsEmpty: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsEmpty,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        case DecimalOperator.IsEqualTo: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsEqualTo,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        case DecimalOperator.IsNotEqualTo: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsNotEqualTo,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        case DecimalOperator.IsLessThan: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsLessThan,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        case DecimalOperator.IsLessThanOrEqualTo: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsLessThanOrEqualTo,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        case DecimalOperator.IsGreaterThan: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsGreaterThan,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        case DecimalOperator.IsGreaterThanOrEqualTo: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsGreaterThanOrEqualTo,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        default:
            break
    }
    return result
}

const parser: FilterParser = {
    Type: DecimalConditionType,
    TypeDTO: DecimalConditionDTOType,
    checkIfApplicable,
    checkIfApplicableDTO,
    parseFromDTO,
    parseToDTO,
}
export default parser
